import type { AllAccountsState } from '../nested-states/all-accounts/states/all-accounts.state';
import type { AdminsState } from '../nested-states/admins/states/admins.state';
import type { TeachersStates } from '../nested-states/teachers/states/teachers.states';
import type { AssistantsStates } from '../nested-states/assistants/states/assistants.states';
import type { StudentsStates } from '../nested-states/students/states/students.states';
import type { CountAccountsState } from '../nested-states/count-accounts/state';
import type { NewUser, User, UserType } from '../../../models/User';
import type { ParentsStates } from '../nested-states/parents/states/parents.states';

export interface RoleProps {
	role: string;
	search: string;
	limit: number;
}

export interface PostRoleProps {
	school_id: string | number;
	user: NewUser;
	userType: UserType;
	roles: string[];
	role?: string;
	behalf?: User[];
}

export interface IAccountsState {
	allAccounts?: AllAccountsState;
	adminsAccounts?: AdminsState;
	teachersAccounts?: TeachersStates;
	assistantsAccounts?: AssistantsStates;
	studentsAccounts?: StudentsStates;
	parentsAccounts?: ParentsStates;
	countAccounts?: CountAccountsState;
}

export const accountsInitialState: IAccountsState = {};
